import React, {useEffect, useState} from 'react';
import Page from "../../Components/Page";
import {LoadingWrapper} from "../../Components/LoadingWrapper";
import ReactTable from "../../Components/ReactTable";
import {Breadcrumbs} from "../../Components/Breadcrumbs";
import SelectDropdown from "../../Components/Dropdowns/SelectDropdown";
import {makeApolloClientCall} from "../../../Api/makeApolloApiCall";
import {makeApiCall} from "../../../Api/makeApiCall";

const GeographyStoreMapping = () => {
    const [loading, setLoading] = useState(true);
    const [geographyStoreMappings, setGeographyStoreMappings] = useState([]);
    const [selectedMarketPeriod, setSelectedMarketPeriod] = useState(undefined);
    const [marketPeriodOptions, setMarketPeriodOptions] = useState([]);

    useEffect(() => {
        makeApolloClientCall('{ marketPeriodList }').then((marketPeriodResults) => {
            setMarketPeriodOptions(marketPeriodResults.marketPeriodList.sort().reverse().map(mp => ({
                label: mp,
                value: mp
            })));
        })
    }, []);

    useEffect(() => {
        if (selectedMarketPeriod === undefined) return;
        setLoading(true);
        const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/geographyStoreMapping/?period=${selectedMarketPeriod}`
        makeApiCall(endpointUrl).then((response) => {
            setGeographyStoreMappings(response)
        }).finally(() => {
            setLoading(false);
        });
    }, [selectedMarketPeriod])

    const customColumns = [
        {header: "Geography Id", accessorKey: "geography_id"},
        {header: "Geography Name", accessorKey: "geography_name"},
        {header: "Store Id", accessorKey: "store_id"},
        {header: "Store Name", accessorKey: "store_name"}
    ];

    return <Page name={"Geography Store Mapping"} beta={true}
                 breadCrumbs={<Breadcrumbs items={[{label: 'Services'}, {label: 'Geography'}, {label: 'Geography Store Mapping'}]}/>}>
        <div className={"geography-store-mapping-container"} data-testid={"geography-store-mapping-container"}>
            <div id={'market_period_dropdown_div'} className={"custom-run-selections-row"}>
                <SelectDropdown id={"market_period_dropdown"}
                                dataTestId={"market_period_dropdown"}
                                inputLabel={"Period"}
                                selectValue={selectedMarketPeriod}
                                options={marketPeriodOptions}
                                onChange={(option) => setSelectedMarketPeriod(option.value)}
                />
            </div>
        </div>
        <br/>
        {selectedMarketPeriod &&
            <LoadingWrapper loading={loading}>
                <ReactTable data={geographyStoreMappings.data}
                            columns={customColumns}
                            initialState={{pagination: {pageSize: 25}, sorting: [{id: "geography_id", desc: false}]}}
                            filterable
                />
            </LoadingWrapper>
        }
    </Page>;
};

export default GeographyStoreMapping;